module.exports = __webpack_public_path__ + "img/female-avatar.426152c.png";